<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-content scrollable">
  <div class="modal-header">
    <h5 class="modal-title" xdaTranslate>SDE_JOBS</h5>
    <button
      type="button"
      class="modal-close-btn"
      data-dismiss="modal"
      aria-label="Close"
      (click)="activeModal.dismiss()">
      <span aria-hidden="true" class="xgl-close"></span>
    </button>
  </div>
  <div class="modal-body" tabindex="-1">
    <div id="jobs-container">
      <!-- For each workflow -->
      @for (
        workflow of workflows;
        track workflow;
        let first = $first;
        let last = $last
      ) {
        <div
          class="job position-relative"
          (click)="expand(workflow)"
          [ngClass]="{
            first: first,
            last: last,
            expanded: expandedWorkflow && expandedWorkflow.id == workflow.id,
          }"
          [@fadeOut]>
          <div class="job-summary">
            <!-- Display icon -->
            <span class="workflow-icon">
              @if (workflow.icon.image) {
                <img
                  class="workflow-image"
                  [src]="workflow.icon.image"
                  [alt]="'SDE_WORKFLOW_ICON' | xdaTranslate" />
              } @else {
                <span
                  class="workflow-image workflow-glyph {{
                    workflow.icon.glyph
                  }} {{
                    workflow.icon.color
                  }} xglsize-32 text-center align-middle"></span>
              }
            </span>
            <!-- Display workflow name -->
            <span class="workflow-name">
              <span class="name-wrapper">
                <span class="name" [xdaTranslate]="workflow.name"></span>
                @if (workflow.pageCount) {
                  <span
                    class="count"
                    [xdaTranslate]="'SDE_FMTSTR_PAGES1'"
                    [formatValues]="workflow.pageCount"></span>
                }
              </span>
              <span
                [xdaTranslate]="'SDE_SUBMITTED_FMTSTR'"
                [formatValues]="
                  (workflow.initiatedAt | date: 'medium') || ''
                "></span>
            </span>
            <!-- Display state glyph -->
            <span
              class="flex-center progress-glyph"
              longTouch
              (longTouch)="report(workflow)">
              @if (
                !isTerminalStateArray(workflow.status!) &&
                !isAPendingStateArray(workflow.status!)
              ) {
                <span
                  class="xrx-activity-indicator ai-sm ai-spin"
                  [placement]="last && !first ? 'top' : 'bottom'"
                  [ngbTooltip]="
                    'SDE_FMTSTR_PROCESSING' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (isErrorStateArray(workflow.status!)) {
                <span
                  class="error xgl-alert xglsize-32"
                  [placement]="last && !first ? 'top' : 'bottom'"
                  [ngbTooltip]="
                    'SDE_FMTSTR_ERROR1' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (isCompletedStateArray(workflow.status!)) {
                <span
                  class="complete xgl-checkmark_circle_break xglsize-32"
                  [placement]="last && !first ? 'top' : 'bottom'"
                  [ngbTooltip]="
                    'SDE_FMTSTR_COMPLETED' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (
                isAPendingStateArray(workflow.status!) &&
                !isErrorStateArray(workflow.status!) &&
                !isTerminalStateArray(workflow.status!)
              ) {
                <span
                  class="waiting xgl-alarmclock xglsize-32"
                  [placement]="last && !first ? 'top' : 'bottom'"
                  [ngbTooltip]="
                    'SDE_USER_INTERACTION_REQUIRED' | xdaTranslate
                  "></span>
              }
              @if (isCanceledStateArray(workflow.status!)) {
                <span
                  class="close xgl-close xglsize-32"
                  [placement]="last && !first ? 'top' : 'bottom'"
                  [ngbTooltip]="
                    'SDE_FMTSTR_CANCELED' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
            </span>
            <!-- Display buttons -->
            <span class="flex-center progress-buttons">
              @if (
                !isTerminalStateArray(workflow.status!) &&
                (!containsServiceName(workflow.status!, 'SDE_SEND_FAX') ||
                  workflow.forceEnableCancel)
              ) {
                <button
                  (click)="cancel($event, workflow)"
                  class="xrx-btn btn-secondary btn-sm"
                  [class.disabled]="workflow.waitToBeCanceled">
                  <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
                </button>
              }
              @if (isTerminalStateArray(workflow.status!)) {
                <button
                  (click)="remove($event, workflow)"
                  class="xrx-btn btn-secondary btn-sm">
                  <span class="btn-label" xdaTranslate>SDE_DISMISS</span>
                </button>
              }
              @if (
                containsServiceName(workflow.status!, 'SDE_SEND_FAX') &&
                !workflow.forceEnableCancel &&
                !isTerminalStateArray(workflow.status!)
              ) {
                <span xdaTranslate>SDE_SENDING3</span>
              }
            </span>
          </div>
          @if (expandedWorkflow && workflow.id == expandedWorkflow.id) {
            <div class="job-details">
              <div>
                <div class="input">
                  <!-- Upload file -->
                  <span class="service-name">
                    @if (!workflow.name.includes('MERGE')) {
                      <span [xdaTranslate]="'SDE_UPLOADING_FILE2'"></span>
                    }
                    @if (workflow.name.includes('MERGE')) {
                      <span [xdaTranslate]="'SDE_UPLOADING_FILES'"></span>
                    }
                  </span>
                  <!-- Display state glyph -->
                  <span class="flex-center progress-glyph">
                    @if (
                      (!workflow.status ||
                        !isTerminalStateArray(workflow.status)) &&
                      !workflow.services?.[0]?.status
                    ) {
                      <span
                        class="xrx-activity-indicator ai-xs ai-spin"
                        placement="left"
                        [ngbTooltip]="
                          'SDE_FMTSTR_PROCESSING' | xdaTranslate
                        "></span>
                    }
                    @if (
                      workflow.status &&
                      isErrorStateArray(workflow.status) &&
                      !workflow.services?.[0]?.status
                    ) {
                      <span
                        class="error xgl-alert xglsize-20"
                        placement="left"
                        [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                    }
                    @if (
                      (workflow.status &&
                        isCompletedStateArray(workflow.status)) ||
                      workflow.services?.[0]?.status
                    ) {
                      <span
                        class="complete xgl-checkmark_circle_break xglsize-20"
                        placement="left"
                        [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                    }
                  </span>
                </div>
                @if (
                  workflow.status &&
                  isErrorStateArray(workflow.status) &&
                  isInsufficientCreditStateArray(workflow.status)
                ) {
                  <div class="entitlements">
                    <span
                      class="service-status"
                      [xdaTranslate]="workflow.status[0].status"></span>
                  </div>
                }
              </div>
              @for (service of workflow.services; track service) {
                <div class="services">
                  <!-- Display service only if it has a status -->
                  @if (service.status) {
                    <div class="service">
                      <!-- Display service name -->
                      <span class="service-name">
                        <span
                          [xdaTranslate]="
                            $any(serviceStatusNames)[service.name] ||
                            service.name
                          "></span>
                      </span>
                      <!-- Display state glyph -->
                      <span class="flex-center progress-glyph">
                        @if (!isTerminalStateArray(service.status)) {
                          <span
                            class="xrx-activity-indicator ai-xs ai-spin"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_PROCESSING1' | xdaTranslate
                            "></span>
                        }
                        @if (isErrorStateArray(service.status)) {
                          <span
                            class="error xgl-alert xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                        }
                        @if (isCompletedStateArray(service.status)) {
                          <span
                            class="complete xgl-checkmark_circle_break xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
              @for (ostatus of workflow.outputStatus; track ostatus) {
                <div class="outputs">
                  @if (!isPendingPrintState(ostatus)) {
                    <div class="output">
                      <!-- Output file status -->
                      <span class="service-name">
                        <span [xdaTranslate]="ostatus.status"></span>
                      </span>
                      <!-- Display state glyph -->
                      <span class="flex-center progress-glyph">
                        @if (
                          !ostatus ||
                          (ostatus &&
                            !isErrorState(ostatus) &&
                            !isCompletedState(ostatus) &&
                            !isPendingDownloadState(ostatus) &&
                            !isPendingPrintState(ostatus))
                        ) {
                          <span
                            class="xrx-activity-indicator ai-xs ai-spin"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_PROCESSING1' | xdaTranslate
                            "></span>
                        }
                        @if (ostatus && isPendingDownloadState(ostatus)) {
                          <span
                            class="waiting xgl-alarmclock xglsize-20"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_USER_INTERACTION_REQUIRED' | xdaTranslate
                            "></span>
                        }
                        @if (
                          ostatus &&
                          !isErrorState(ostatus) &&
                          isCompletedState(ostatus)
                        ) {
                          <span
                            class="complete xgl-checkmark_circle_break xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                        }
                        @if (ostatus && isErrorState(ostatus)) {
                          <span
                            class="error xgl-alert xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
              @if (isPendingPrintStateArray(workflow.status!)) {
                <div class="output">
                  <!-- Print ready status -->
                  <span class="service-name print-status">
                    @if (isOutputTypePrint(workflow.output.outputOptions)) {
                      <span [xdaTranslate]="'SDE_ACCESS_JOB_WORKFLOW'"></span>
                    }
                  </span>
                </div>
              }
              <!-- workflow known errors -->
              @if (isErrorStateArray(workflow.status!)) {
                <div class="error">
                  <span class="service-name">
                    <span
                      class="wrap"
                      [xdaTranslate]="getErrorMessage(workflow.status!)"></span>
                  </span>
                </div>
              }
              @if (
                (workflow.status && isErrorStateArray(workflow.status)) ||
                isCanceledStateArray(workflow.status!)
              ) {
                <div class="error">
                  @if (isCanceledStateArray(workflow.status!)) {
                    <span class="error-status">
                      <span xdaTranslate>SDE_WORKFLOW_CANCELED</span>
                    </span>
                  }
                </div>
              }
              @if (isPendingDownloadStateArray(workflow.status!)) {
                <div class="output">
                  <!-- Download ready status -->
                  <span class="service-name">
                    @if (
                      isDownloadOption(workflow.output.outputOptions || []) &&
                      !isCanceledStateArray(workflow.status!)
                    ) {
                      <button
                        (click)="download($event, workflow)"
                        class="xrx-btn btn-secondary btn-sm"
                        xdaTranslate>
                        SDE_DOWNLOAD
                      </button>
                    }
                  </span>
                </div>
              }
              @if (
                isPendingHeldStateWorkflow(workflow) &&
                !isCanceledStateArray(workflow.status!) &&
                !workflow.interimContinued
              ) {
                <div class="output">
                  <!-- Interim Download ready status -->
                  <span class="service-name">
                    <button
                      (click)="downloadInterim($event, workflow)"
                      class="xrx-btn btn-secondary btn-sm mr-2"
                      [class.disabled]="workflow.interimDownloaded"
                      [ngbTooltip]="
                        (workflow.interimDownloaded
                          ? 'SDE_DOWNLOAD_NO_LONGER'
                          : 'SDE_DOWNLOAD_REVIEW_JOB'
                        ) | xdaTranslate
                      "
                      tooltipClass="interim-tooltip"
                      triggers="hover"
                      xdaTranslate>
                      SDE_DOWNLOAD
                    </button>
                    @if (
                      !(
                        workflow.status && isCanceledStateArray(workflow.status)
                      )
                    ) {
                      <button
                        (click)="continue($event, workflow)"
                        class="xrx-btn btn-secondary btn-sm"
                        [ngbTooltip]="
                          'SDE_CONTINUE_PROCESSING_JOB' | xdaTranslate
                        "
                        tooltipClass="interim-tooltip"
                        triggers="hover"
                        xdaTranslate>
                        SDE_CONTINUE
                      </button>
                    }
                  </span>
                </div>
              }
              <span class="flex-center progress-buttons d-none show-on-xs">
                @if (
                  !isTerminalStateArray(workflow.status!) &&
                  (!containsServiceName(workflow.status!, 'SDE_SEND_FAX') ||
                    workflow.forceEnableCancel)
                ) {
                  <button
                    (click)="cancel($event, workflow)"
                    class="xrx-btn btn-secondary btn-sm"
                    [class.disabled]="workflow.waitToBeCanceled">
                    <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
                  </button>
                }
                @if (isTerminalStateArray(workflow.status!)) {
                  <button
                    (click)="remove($event, workflow)"
                    class="xrx-btn btn-secondary btn-sm">
                    <span class="btn-label" xdaTranslate>SDE_DISMISS</span>
                  </button>
                }
              </span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
